<template>
  <div class="accounts">
    <n-tabs type="line" animated @update:value="onTabChange">
      <n-tab-pane name="management" tab="Account Management">
        <AccountManagement />
      </n-tab-pane>
      <n-tab-pane name="projections" tab="Savings Projections">
        <SavingsProjection />
      </n-tab-pane>
    </n-tabs>
  </div>
</template>

<script setup>
import { NTabs, NTabPane } from 'naive-ui';
import AccountManagement from '../components/AccountManagement.vue';
import SavingsProjection from '../components/SavingsProjection.vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const onTabChange = (tab) => {
  router.replace({ hash: tab });
};
</script>